import { Component, effect, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MergeTargetModel, MergeTargetsModel, PatientReminderModel, PatientTargetModel, PromptCodeModel, PromptScheduleModel } from '../../core/api/models';
import { SupervisorApiService } from '../../core/api/services';
import { AlertService } from '../../shared/services/alert.service';
import { SettingsHelperService } from '../../settings/settings.helper.service';
import { Utils } from '../../core/utils';
import { SharedModule } from "../../shared/shared.module";
import { SupervisorHelperService } from '../../supervisor/supervisor.helper.service';
import { PatientDataFacadeService } from '../../core/services/patient-data-facade.service';
@Component({
  selector: 'app-merge-targets',
  templateUrl: './merge-targets.component.html',
  standalone: false,
})
export class MergeTargetsComponent {
  patientID: string = '';
  patientIDLoaded: boolean = false;
  loading: boolean = false;

  targetsToMerge: {
    TargetIDToMerge?: number;
    TargetIDToMergeInto?: number;
    destinationTargets: PatientTargetModel[];
  }[] = [];
  sourceTargets: PatientTargetModel[] = [];
  destinationTargets: PatientTargetModel[] = [];
  allTargets: PatientTargetModel[] = [];

  parentName: { [key: number]: string } = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private supervisorApiService: SupervisorApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService,
    private router: Router,
    private patientDataFacade: PatientDataFacadeService
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.patientID = params['patientID'];
      this.patientIDLoaded = true;
      if (!this.patientID) {
        this.router.navigate(['/select-patient']);
      }
      if (!this.supervisorHelperService.targets().length || !this.supervisorHelperService.targets().find((t) => t.PatientID === parseInt(this.patientID))) {

        this.loading = true;
        const getTargetsObservable = this.patientDataFacade.getTargets(
          parseInt(this.patientID),
          {
            onlyActive: false,
          }
        );
        getTargetsObservable.subscribe({
          next: (targets: PatientTargetModel[]) => {
            this.supervisorHelperService.targets.set(targets)
            this.initLoadTargets(targets);
            this.loading = false;
          },
          error: (error: any) => {
            this.loading = false;
          }
        });
      } else {
        this.initLoadTargets(this.supervisorHelperService.targets());
      }
    });
  }

  initLoadTargets(targets: PatientTargetModel[]) {
    this.allTargets = targets;
    this.sourceTargets = this.allTargets.filter((t) => true);
    this.destinationTargets = this.allTargets.filter((t) => true);
    this.parentName = this.allTargets.reduce((acc, t) => {
      if (t.ID) {
        const parent = this.allTargets.find((t2) => t2.SubTargets?.some((st) => st.ID === t.ID));
        acc[t.ID] = parent?.TargetName ?? '';
      }
      return acc;
    }, {} as { [key: number]: string });

    this.targetsToMerge = [
      {
        TargetIDToMerge: 0,
        TargetIDToMergeInto: 0,
        destinationTargets: this.destinationTargets.filter((t) => true)
      }
    ]
  }

  onSourceTargetChange(target: { TargetIDToMerge?: number; TargetIDToMergeInto?: number; destinationTargets: PatientTargetModel[]; }) {
    console.log(target);
    target.destinationTargets = this.allTargets.filter((t) => t.ID !== target.TargetIDToMerge && t.TargetType === this.allTargets.find((t) => t.ID === target.TargetIDToMerge)?.TargetType);
  }

  addTarget() {
    this.targetsToMerge.push({
      TargetIDToMerge: 0,
      TargetIDToMergeInto: 0,
      destinationTargets: this.allTargets.filter((t) => true)
    });
  }

  mergeTargets() {
    if (this.targetsToMerge.length <= 0) {
      this.alertService.error('Please select at least one target to merge');
      return;
    }
    for (const t of this.targetsToMerge) {
      if (t.TargetIDToMerge === 0 || t.TargetIDToMergeInto === 0) {
        this.alertService.error('Please select a target to merge and a target to merge into');
        return;
      }
    }

    this.alertService.confirm('Are you sure you want to merge the selected targets data and delete the source targets? This operation cannot be undone.', 'Confirm').subscribe({
      next: (result: boolean) => {
        if (result) {
          this.loading = true;
          this.supervisorApiService.MergeTargets({
          body: {
            MergeTargets: this.targetsToMerge
          }
        }).subscribe({
          next: (response) => {
            this.loading = false;
            this.alertService.success('Targets merged successfully');
          },
          error: (error) => {
            this.loading = false;
            this.alertService.error('Error merging targets');
            console.log(error);
          }
          });
        }
      }
    });
  }
}

